import { useEffect, useState } from "react";
import { backend_url } from "../App";
import { menuItems as defaultMenu } from "../Constants/menuItems";

// Top navigation menu, editable from Admin → HomePage → Website Menu.
// Falls back to the built-in menu (Constants/menuItems) when nothing is saved
// or the server can't be reached, so the navbar always renders.
const CACHE_KEY = "siteMenuCache";

// Drop entries an admin has hidden
const visible = (items) =>
  items
    .filter((i) => !i.hidden)
    .map((i) => (i.dropdown ? { ...i, dropdown: i.dropdown.filter((d) => !d.hidden) } : i));

const readCache = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(CACHE_KEY));
    return Array.isArray(cached) && cached.length ? cached : null;
  } catch {
    return null;
  }
};

const useSiteMenu = () => {
  // last saved menu from this browser first, to avoid a flash of the old menu
  const [menu, setMenu] = useState(() => readCache() || defaultMenu);

  useEffect(() => {
    let cancelled = false;
    fetch(`${backend_url}/api/site-menu`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled || !data.success) return;
        if (Array.isArray(data.items) && data.items.length) {
          const items = visible(data.items);
          setMenu(items);
          try { localStorage.setItem(CACHE_KEY, JSON.stringify(items)); } catch { /* ignore */ }
        } else {
          setMenu(defaultMenu); // nothing saved — built-in menu
          try { localStorage.removeItem(CACHE_KEY); } catch { /* ignore */ }
        }
      })
      .catch(() => { /* keep current menu */ });
    return () => { cancelled = true; };
  }, []);

  return menu;
};

export default useSiteMenu;
